
/**
 * Created by nijin on 9/2/17.
 */
import { Injectable } from '@angular/core';
import {environment} from "../../environments/environment";
import {HttpService} from "../auth/http.client.service";
import {URLSearchParams, RequestOptions, Response} from "@angular/http";
import {Observable, Subject} from "rxjs";
declare const drift;
@Injectable()
export class GlobalService {
  SCHEMA_CATEGORY = 'category';
  LOCATION_DATA_TYPE = 'data-type-locations';
  ATTRIBUTE_DATA_TYPE = 'data-type-attributes';
  LOCATION_TYPES = 'location-types';
  DATA_TYPE_JSON = 'json';
  DATA_TYPE_BOOLEAN = 'boolean';
  DATA_TYPE_NUMBER = 'number';
  DATA_TYPE_STRING = 'string';
  BLOG_URL = 'https://medium.com/cantiz';

  private appDetails: any = {};
  private configurationURI = `${environment.serviceBase}/configurations`;
  private termsPopupSubject = new Subject();
  private orgDesignations = [
    'CXO',
    'VP',
    'Director',
    'Developer',
    'Manager',
    'Educator',
    'Researcher',
    'Student'
  ];

  constructor(private http: HttpService) { }

  getConfigDataByType(param): Observable<any> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('type', param);
    let options = new RequestOptions({search: params });
    return this.http.get(this.configurationURI, options)
      .map(this.extractData)
      .catch(this.handleError);
  }


  getPopupSubject(): Observable<any> {
    return this.termsPopupSubject.asObservable();
  }

  getValueByType(attribute) {
    let value;
    switch (attribute.datatype) {
      case this.DATA_TYPE_BOOLEAN:
        value = true;
        break;
      case this.DATA_TYPE_NUMBER:
        value = Math.floor(Math.random() * (10000 - 1000)) + 1000;
        break;
      default:
        value = attribute.name;
        break;
    }

    return value;
  }

  nextPopupState(isOpen) {
    this.termsPopupSubject.next(isOpen);
  }

  getAllDesignations() {
    return this.orgDesignations;
  }

  private  extractData(response: Response) {
    let body = response.json();
    return body.data || { };
  }

  private handleError(error: Response) {
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    }

    return Observable.throw(errMsg);
  }
  fetchData(url: string) {
    this.http.get(url)
      .map(this.extractData)
      .catch(this.handleError);
  }

  manageDriftWidget() {
    drift.on('ready', (api, payload) => {
      api.widget.hide();
      api.hideChat();
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/global/global.service.ts